
import parse from "html-react-parser";
import { PosTask } from "../../interfaces/Task";
import { Media } from "../../interfaces/Media";
import MediaPreview from "../../elements/MediaPreview";
import { Table } from "react-bootstrap";
import { replaceOembed } from "../../../utils/utils";
import { t } from "i18next";

export interface SitePosTaskProps {
    postask: PosTask;
    mode: string;
}

export default function SitePosTask(props: SitePosTaskProps) {
    return(
        <div className="site-postask">
            <div className="inner">
                <div className="postask-name">
                    <strong>{ props.postask.name }</strong>
                </div>
                <div className="postask-content">
                    { props.postask.instructions &&
                        <div className={ 'instructions' + (props.postask.media.filter((m: Media) => m.share == true).length == 0 ? ' no-medias' : '') }>
                            <label><strong>{ t("Aim and instructions") }</strong></label>
                            <div className="value">{ parse(replaceOembed(props.postask.instructions)) }</div>
                        </div>
                    }
                    { props.postask.media.length > 0 &&
                        <div className="medias-list">
                            <Table responsive={ true }>
                                <thead>
                                    <tr>
                                        <th>{ t("Resource") }</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { props.postask.media.map((m: Media) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <MediaPreview media={ m } />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    }
                    { props.postask.teacher_notes && props.mode == 't' &&
                        <div className={ 'teacher-notes' }>
                            <label><strong>{ t("Teacher notes") }</strong></label>
                            <div className="value">{ parse(replaceOembed(props.postask.teacher_notes)) }</div>
                        </div>
                    }
                    { props.postask.text &&
                        <div className="text">
                            <label><strong>{ t("Text") }</strong></label>
                            <div className="value">{ parse(replaceOembed(props.postask.text)) }</div>
                        </div>
                    }
                    { !props.postask.text &&
                        <div className="text">
                            { 'No text specified for this pre-task' }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}